/*
 * Every brand image lives in the site's storage behind its CDN.
 * The CDN host follows the free subdomain: if the subdomain changes, update CDN_BASE here.
 */
export const CDN_BASE = 'https://khuzkimia-zagros.cdn.modulify.website'

const brandImage = (file: string): string => `${CDN_BASE}/images/brand/${file}`

export const MEDIA = {
    heroProducts: brandImage('zagros-products-sunrise.png'),
    productLineup: brandImage('product-lineup.png'),
    laboratory: brandImage('laboratory.jpg'),
    packagingLine: brandImage('packaging-line.png'),
    globalExportEn: brandImage('global-export-en.png'),
    globalExportFa: brandImage('global-export-fa.png'),
    globeEmblem: brandImage('kz-globe-emblem.jpg'),
    attariEmblem: brandImage('attari-emblem.png'),
    office: brandImage('office.jpg'),
    brandBoardDark: brandImage('brand-board-dark.png'),
    brandBoardLight: brandImage('brand-board-light.png'),
    socialPosts: brandImage('social-posts.png'),
    exportContact: brandImage('export-contact.png'),
    zagrosValley: '/images/zagros-valley.jpg'
} as const

/* Remote images on the site's own CDN go through the image optimizer, anything else is shown as is */
export const isOptimizableImage = (src: string): boolean => {
    if (src.startsWith('/')) return true

    try {
        return new URL(src).hostname.endsWith('.cdn.modulify.website')
    }
    catch {
        return false
    }
}
